<template>
	<div class="container">
		<div class="nav_box">
			<div class="top_box">
				<div class="left">
					<img src="../../assets/img_h5/logo.png" @click="goIndex" />
				</div>
				<div class="right">
					<div v-if="userMsg" class="out_box">
						<span @click="goInfo">Hello, {{ userMsg }} </span>
						<i class="el-icon-switch-button" style="" @click="goOut"></i>
					</div>
					<van-icon v-else name="contact" size="24" color="#000" style="top: 2px;" @click="goSign" />
					<van-badge :content="idsStr.length" max="99999" color="#E37542">
						<van-icon class="img_el" name="orders-o" size="24" color="#006BB3" style="top: 2px;" @click="goMyList" />
					</van-badge>
					<van-icon v-if="!isShow"  class="img_el" name="wap-nav" size="28" color="#006BB3" style="top: 3px;" @click="showSlide" />
					<van-icon v-else class="img_el" name="close" size="28" color="#006BB3" style="top: 3px;" @click="showSlide" />
				</div>
			</div>
			<!--折叠导航-->
			<div class="slide_box" :class="isShow ? 'height-slide' : ''" :border="false">
				<div class="search_box">
					<div class="input_box">
						<input v-model="inputVal" placeholder="Search by Name, or Keyword" @keyup.enter="goSearch" />
						<van-icon name="search" class="icon" size="20" color="#006BB3" @click="goSearch" />
					</div>
				</div>
				<div style="padding: 16px;border-bottom: 1px solid #E3E1E6;font-size: 16px;font-weight: bold;" @click="goIndex">Home</div>
				<div
					v-for="(value, index) in navList"
					:key="index"
					style="display: flex;align-items: center;;padding: 16px;border-bottom: 1px solid #E3E1E6;font-size: 16px;font-weight: bold;"
				>
					<div class="left" style="flex: 1;" @click="goNav(value)">
						{{ value.title }}
					</div>
					<div v-if="value.route == 'Products'" class="right" style="width: auto;font-size: 14px;color: rgb(0, 107, 179);" @click="showType">
						Category
					</div>
				</div>
			</div>
			<!--折叠导航-->
		</div>
		<!--筛选弹框-->
		<div>
			<van-popup
				v-model="filterVisible"
				position="right"
				:close-on-click-overlay="true"
				closeable
				:style="{ width: '70%', height: '100%' }"
			>
				<div class="filter_popup">
					<div class="products_box_el">
						<div v-for="(value, index) in productType" :key="index" class="title" @click="goNavChild(1, value)">{{ value.title }}</div>
						<div class="title" @click="goNavChild(1, 'NC Membranes')">NC Membrane</div>
					</div>
					<div v-if="false" class="products_box_el" style="padding-top: 20px;">
						<div v-for="(value, index) in productList" :key="index" class="title" @click="goNavChild(2, value)">{{ value.title }}</div>
					</div>
				</div>
			</van-popup>
		</div>
		<!--筛选弹框-->
	</div>
</template>

<script>
// import { submitMsg } from '@/api/public';  //提交留言
import { userCart } from '@/api/public';  //保存购物车
export default {
	components:{
		//
	},
	data() {
		return {
			navList: [],
			activeName: '',
			isShow: false,
			inputVal: '',
			productType: [],
			productList: [],
			idsStr: [],
			ids: [],
			userMsg: '',
			filterVisible: false,
		}
	},
	created(){
		let that = this;
		if(JSON.parse(localStorage.getItem('idsStr'))) {
			that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
		}
		if(JSON.parse(localStorage.getItem('ids'))) {
			that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
		}
		if(sessionStorage.getItem('navData')) {
			// that.navList = JSON.parse(sessionStorage.getItem('navData')).cate;
			that.navList = JSON.parse(sessionStorage.getItem('navData')).cate.filter(function(element) {
				return element.title !== 'Services';
			})
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			that.productList = JSON.parse(sessionStorage.getItem('navData')).diseases_list;
		}
		//处理用户名
		if(localStorage.getItem('firstName')) {
			if(localStorage.getItem('firstName').length > 7) {
				that.userMsg = localStorage.getItem('firstName').slice(0, 7) + '...';
			}else {
				that.userMsg = localStorage.getItem('firstName');
			}
		}else if(localStorage.getItem('email')) {
			if(localStorage.getItem('email').length > 7) {
				that.userMsg = localStorage.getItem('email').slice(0, 7) + '...';
			}else {
				that.userMsg = localStorage.getItem('email');
			}
		}
	},
	mounted() {
		let that = this;
	},
	methods: {
		//点击展示产品分类
		showType() {
			let that = this;
			that.filterVisible = true;
		},
		//更新清单角标
		initCount() {
			let that = this;
			that.idsStr = [];
			that.ids = [];
			if(JSON.parse(localStorage.getItem('idsStr'))) {
				that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
			}
			if(JSON.parse(localStorage.getItem('ids'))) {
				that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
			}
		},
		//退出登录
		goOut() {
			let that = this;
			// that.$dialog.confirm({
			// 	title: 'Tips',
			// 	message: 'Your current login account is: '+that.userMsg+'. Are you sure you want to log out?',
			// 	confirmButtonText: 'Confirm',
			// 	confirmButtonColor: '#006BB3',
			// 	cancelButtonText: 'Cancel'
			// }).then(() => {
				if(that.idsStr.length > 0 && that.ids.length > 0) {
					that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
					userCart({
						product_list: that.idsStr.join(','),
						product_id: that.ids.join(',')
					}).then(res => {
						that.$toast.clear();
						localStorage.clear();
						sessionStorage.clear();
						that.$toast('Exit successful');
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					});
				}else {
					that.$toast('Exit successful');
					localStorage.clear();
					sessionStorage.clear();
					setTimeout(() => {
						window.location.reload();
					}, 1000);
				}
			// }).catch(() => {});
		},
		//跳转清单
		goMyList() {
			if(this.$route.path != '/watch-list') {
				this.isShow = false;
				this.$router.push({ path: '/watch-list' });
			}else {
				window.location.reload();
			}
		},
		//跳转搜索
		goSearch() {
			if(this.inputVal) {
				if(this.$route.path != '/products') {
					this.$router.push({ path: '/products', query: { search: this.inputVal } });
				}else {
					this.$router.push({ path: '/products', query: { search: this.inputVal } });
					window.location.reload();
				}
			}else {
				this.$toast('Please enter name, keywords or catalog number to search.');
			}
		},
		//子导航点击
		goNavChild(type, value) {
			let that = this;
			if(that.$route.path != '/products') {
				if(type == 1) {
					if(value == 'NC Membranes') {
						window.location.href = 'https://i-membrane.com/';
					}else {
						that.$router.push({ path: '/products', query: { type: value.id } });
					}
				}else if(type == 2) {
					that.$router.push({ path: '/products', query: { disease: value.id } });
				}
			}else {
				if(type == 1) {
					if(value == 'NC Membranes') {
						window.location.href = 'https://i-membrane.com/';
					}else {
						that.$router.push({ path: '/products', query: { type: value.id } });
					}
				}else if(type == 2) {
					that.$router.push({ path: '/products', query: { disease: value.id } });
				}
				window.location.reload();
			}
		},
		//导航点击
		goNav(value) {
			let that = this;
			that.isShow = false;
			if(value.route != 'Careers') {
				if(value.url == '/products') {
					if(that.$route.path != value.url) {
						that.$router.push({ path: '/products' });
					}else {
						that.$router.push({ path: '/products' });
						setTimeout(() => {
							window.location.reload();
						}, 300);
					}
				}else {
					if(that.$route.path != value.url) {
						that.$router.push({ path: value.url });
					}else {
						window.location.reload();
					}
				}
			}else {
				window.location.href = value.url;
			}
		},
		//显示/隐藏导航
		showSlide() {
			let that = this;
			that.isShow = !that.isShow;
		},
		//点击进入完善信息
		goInfo() {
			if(this.$route.path != '/information') {
				this.isShow = false;
				this.$router.push({ path: '/information' });
			}else {
				window.location.reload();
			}
		},
		//跳转登录
		goSign() {
			let that = this;
			if(that.$route.path != '/sign-in') {
				that.filterVisible = false;
				that.isShow = false;
				that.$router.push({ path: '/sign-in' });
			}else {
				window.location.reload();
			}
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.filterVisible = false;
				that.isShow = false;
				that.$router.push({ path: '/', });
			}else {
				window.location.reload();
			}
		},
	}
}
</script>

<style lang="less" scoped>
.filter_popup{
	padding: 30px 20px;
	.products_box_el{
		.title{
			padding: 10px 0;
			border-bottom: 1px solid #f8f8f8;
			font-size: 16px;
		}
	}
}
.nav_box{
	color: #000000;
	font-size: 14px;
	.slide_box {
		position: absolute;
		z-index: 2;
		width: 100%;
		background-color: #ffffff;
		max-height: 0;
		transition: max-height 0.75s;
		overflow: hidden;
		height: 100vh;
		background-color: #ffffff;
		// padding: 0px 16px 0 16px;
		.search_box{
			padding: 16px;
			border-bottom: 1px solid rgb(227, 225, 230);
			.input_box{
				width: 100%;
				display: inline-block;
				position: relative;
				margin-right: 24px;
				.icon{
					position: absolute;
					top: 6px;
					right: 10px;
					cursor: pointer;
				}
				input{
					width: 100%;
					height: 35px;
					padding: 4px 35px 0 10px;
					color: #006BB3;
					font-size: 16px;
					line-height: 35px;
					border-radius: 6px 6px 6px 6px;
					border: 1px solid #808080;
				}
			}
		}
		.van-collapse{
			padding: 10px 0 0 0;
			.van-collapse-item{
				padding: 16px 0 0 0;
				border-bottom: 1px solid #E3E1E6;
			}
		}
		.title{
			padding-bottom: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		.text{
			padding-bottom: 15px;
			font-size: 16px;
			color: #666666;
		}
		div.actived{
			background-color: #f5f8fa;
			color: #0B318F;
		}
	}
	.height-slide {
		max-height: 1000px;
	}
	.top_box{
		display: flex;
		align-items: center;
		position: relative;
		padding: 15px 16px;
		z-index: 1;
		background-color: #ffffff;
		border-bottom: 1px solid #F7F6F9;
		.right{
			width: auto;
			.out_box{
				display: inline-block;
				position: relative;
				top: -3px;
				span{
					font-size: 18px;
				}
				.el-icon-switch-button{
					font-size: 18px;
				}
			}
			.img_el{
				margin-left: 15px;
			}
		}
		.left{
			flex: 1;
			img{
				// width: 100px;
				height: 30px;
			}
		}
	}
}
</style>

<style scoped>
>>> .slide_box .van-hairline--top-bottom::after, >>> .slide_box .van-hairline-unset--top-bottom::after{
	border: none;
}
>>> .slide_box .van-cell, >>> .slide_box .van-collapse-item__content{
	padding: 0;
}
>>> .slide_box .van-cell--clickable{
	background-color: transparent;
}
</style>